/**
 * API 配置工具
 * 用于根据环境动态获取 API baseURL
 */

const { REACT_APP_ENV = 'dev', MANAGER_API_URL } = process.env;

/**
 * @name 获取 API 基础 URL
 * @description 根据环境变量和运行环境返回对应的 API URL
 */
export const getApiBaseUrl = () => {
    console.log(REACT_APP_ENV, process.env.NODE_ENV);
    // 生产环境使用环境变量
    if (REACT_APP_ENV === 'prod' || process.env.NODE_ENV === 'production') {
        return MANAGER_API_URL || 'https://crmkzpmwqnv.blinzoq.xyz';
    }
    // 开发环境使用本地地址
    return 'http://localhost:3000';
}; 